import React, { useState } from "react";
import { ChevronDown, Check, Plus, X } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

const Group = ({ icon: Icon, color, title, items }) => (
  items?.length ? (
    <div>
      <div className={`flex items-center gap-2 text-xs uppercase tracking-[0.14em] mb-2 ${color}`}><Icon className="h-4 w-4" /> {title}</div>
      <ul className="space-y-1.5">{items.map((it) => <li key={it} className="text-sm text-secondary flex items-start gap-2"><span className={color}>•</span> {it}</li>)}</ul>
    </div>
  ) : null
);

export const IncludedChecklist = ({ checklist }) => {
  const [open, setOpen] = useState(true);
  if (!checklist) return null;
  return (
    <Collapsible open={open} onOpenChange={setOpen} data-testid="included-checklist" className="ascendia-card p-6">
      <CollapsibleTrigger className="flex w-full items-center justify-between">
        <span className="font-display text-lg font-semibold text-white">What's included</span>
        <ChevronDown className={`h-5 w-5 text-gold-soft transition-transform ${open ? "rotate-180" : ""}`} />
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-5 grid sm:grid-cols-3 gap-6">
        <Group icon={Check} color="text-gold" title="Included" items={checklist.included} />
        <Group icon={Plus} color="text-gold-soft" title="Optional add-on" items={checklist.optional} />
        <Group icon={X} color="text-muted-c" title="Not included" items={checklist.not_included} />
      </CollapsibleContent>
      <p className="mt-5 text-xs text-muted-c">Optional items are quoted separately. This prevents any confusion about scope before we start.</p>
    </Collapsible>
  );
};

export default IncludedChecklist;
